;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();export default function AcademyGroup() {
  return (
    <svg width="119" height="124" viewBox="0 0 119 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4703 56.7801C28.466 56.7801 32.9451 51.7701 32.9451 45.6001V41.8701C32.9451 35.7001 28.466 30.6899 22.4703 30.6899C16.4747 30.6899 11.9955 35.7001 11.9955 41.8701V45.6001C11.9955 51.7701 16.4747 56.7801 22.4703 56.7801Z"
        stroke="#64348C"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M46.0499 28.0901C52.0455 28.0901 56.5247 23.0799 56.5247 16.9099V13.1799C56.5247 7.00994 52.0455 2 46.0499 2C40.0543 2 35.5751 7.00994 35.5751 13.1799V16.9099C35.5751 23.0799 40.0543 28.0901 46.0499 28.0901Z"
        stroke="#64348C"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M22.088 99.91L13.6218 98.1202C11.1312 97.7702 9.44393 97.22 7.11397 93.72L4.87441 88.8101C2.906 84.4901 1.5 82.6399 1.5 79.1299C1.5 71.7799 5.27613 64.6201 13.6017 64.6201H28.7063C33.547 64.8201 36.5197 65.6601 39.161 68.8301C41.8023 72.0001 44.2829 75 44.2829 75"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9236 78.3896L16.2937 84.2898C17.2377 86.6398 18.3827 87.5697 20.5921 88.3797L26.6882 90.5398"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.0878 95.9099H40.8383C40.3361 89.7099 45.7493 85.48 45.7493 85.48H54.0648C55.8926 85.48 57.0777 87.52 56.2642 89.26L54.4866 93.04C53.6531 94.8101 51.9558 95.9199 50.0878 95.9199V95.9099Z"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M52.7995 85.51L56.2341 78.51C57.0175 76.91 55.8525 75.04 54.0648 75.04H35.8168C34.923 75.04 34.1095 75.5501 33.7078 76.3501L21.9074 100.27C21.114 101.87 22.289 103.74 24.0766 103.74H42.3247C43.2185 103.74 44.032 103.23 44.4337 102.43L47.6474 95.9199"
        stroke="#A7DADB"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M11.9854 97.8003V119.39" stroke="#64348C" strokeWidth="3" strokeLinejoin="round" />
      <path d="M38.1863 103.74V119.39" stroke="#64348C" strokeWidth="3" strokeLinejoin="round" />
      <path
        d="M40.8076 35.9102H46.05C51.8347 35.9102 56.5248 40.5803 56.5248 46.3403"
        stroke="#64348C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path d="M90.5814 98.52V122" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M74.8635 98.52V122" stroke="#64348C" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M90.5808 21.1299V24.3601C90.5808 29.3001 86.8248 33.3001 81.8034 33.3001H77.4849V19.8999"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.8635 20.26C80.1059 20.26 85.0772 15.83 86.684 13.48"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.8238 12.4299C95.8238 7.20994 89.3762 2 81.4122 2C73.4481 2 67.0005 7.9999 67.0005 15.3899V30.69C67.0005 33.62 65.4439 34.85 64.3793 35.91"
        stroke="#64348C"
        strokeWidth="3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M59.5376 66.9803C60.3912 62.4703 61.2248 57.0802 61.7672 54.1702C63.0426 47.2502 66.186 41.1302 74.8631 41.1302H89.2748C89.2748 41.1302 102.702 30.9603 107.091 26.2503C112.584 20.3603 121.533 28.0203 115.477 35.0203L95.8228 55.4803L101.065 98.5204H64.3884L72.252 54.1702"
        stroke="#64348C"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
